import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ModalDialog, Button } from '@mssgme/ui';

export default function InstallDialog({ onInstall, ...rest }) {
    const { t } = useTranslation();
    const name = 'mssg.me';

    return (
        <ModalDialog title={t('InstallDialog.heading', { name })} modal={{ size: 'small' }} {...rest}>
            <p>{t('InstallDialog.content', { name })}</p>
            <p>
                <Button fullWidth onClick={onInstall}>
                    {t('InstallDialog.install')}
                </Button>
            </p>
        </ModalDialog>
    );
}

InstallDialog.propTypes = {
    ...ModalDialog.propTypes,
    onInstall: PropTypes.func.isRequired,
};
